import ExpandMore from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from '@mui/material'
import type { FC } from 'react'
import EditManualsTable from 'src/features/templateEdit/editManual/EditManualsTable'

const ManualRow: FC = () => (
  <Stack sx={{ mt: 2, mx: 2 }}>
    <Accordion
      defaultExpanded
      disableGutters
      elevation={0}
      data-testid="manual-table"
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography>マニュアルを追加</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 0 }}>
        <EditManualsTable />
      </AccordionDetails>
    </Accordion>
  </Stack>
)

export default ManualRow
